import { TransportOrderDetailsDto, TransportOrderUpdateDto } from "../../../models/transport/transportOrder";
import { GeolocationPosition } from "../../../models/workShiftTimeSlot/workTimeStartFormItem";

export type HandleSaveProps = (
    updatedFields?: Partial<TransportOrderDetailsDto>,
    location?: GeolocationPosition | null
) => Promise<void>;

export const toUpdateDto = (
    details: TransportOrderDetailsDto,
    updatedFields: Partial<TransportOrderUpdateDto> = {},
    location?: GeolocationPosition
): TransportOrderUpdateDto =>{
    const {
        name,
        vehicleId,
        employeeId,
        scheduledStartDateTime,
        scheduledEndDateTime,
        state,
        transportDetails,
        orderTypeId,
        formData,
        formValues,
        uiSchema,
        senderBusinessId,
        senderCustomerId,
        receiverBusinessId,
        receiverCustomerId,
        driverComments,
        billingCustomerId,
        modifiedEmployeeId,
        products,
        geolocation,
    } = { ...details, ...updatedFields };

    const dto: TransportOrderUpdateDto = {
        name,
        vehicleId,
        employeeId,
        scheduledStartDateTime,
        scheduledEndDateTime,
        state,
        transportDetails,
        orderTypeId,
        formData,
        formValues,
        uiSchema,
        senderBusinessId,
        senderCustomerId,
        receiverBusinessId,
        receiverCustomerId,
        driverComments,
        billingCustomerId,
        modifiedEmployeeId: modifiedEmployeeId,
        products,
        geolocation,
    };

    if (location) {
        dto.location = location;
    }

    return dto;
};
